import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";
import DatePicker from "vue2-datepicker"

import { STATUS_CODES } from "@/app/constants/status-constants"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

const ModalAddEditReminderNote = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "modal-add-edit-reminder-notes" */ "@/app/views/main-view/breeding-management/puppy-management/modals/modal-add-edit-reminder-note/modal-add-edit-reminder-note.vue"
    );

export default {
	name: 'LitterReminderNotes',
	components: { DatePicker, ModalAddEditReminderNote },
	directive: {},
	filters: {},
	mixins: [tableMixins, dateMixins, toastMessageMixins],
	props: {},
	data() {
		return {
			isAPILoading: false,
			// table
			theads: [
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, style: "width: 100px" },
				{
					name: "Reminder Type",
					hasSearch: true,
					searchLabel: "f_reminderType",
					sortLabel: "reminderType",
					isDesc: false,
					style: "max-width: 190px;"
				},
				{
					name: "Reminder Note",
					searchLabel: "f_notes",
					sortLabel: "notes",
					hasSearch: true,
					isDesc: false,
					style: "min-width: 200px;"
				},
				{
					name: "Reminder Date",
					hasSearch: false,
					hasDateFilter: true,
					searchLabel: "f_reminderDateTime",
					sortLabel: "reminderDateTime",
					isDesc: false,
					style: "min-width: 220px;",
					placeholder: 'DD-MMM-YYYY'
				},
				
			],
			selectedReminderType: '',
			selectedDateFilter: '',

			matingId: null,
			reminderId: null,

			limit: 10,
			page: 1,
			desc: true,
			totalCount: 0,
		}

	},
	computed: {},
	watch: {
		selectedDateFilter() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, true)
		},
		async '$route.query.reminderId'(newVal) {
            if (newVal) {
				const reminder = await breedingManagementService.getLitterReminderNotesById(this.matingId, newVal)
				this.showAddEditReminderModal("Notif", reminder.data)
            }
        }
	},
	async created() {
		this.matingId = this.$route.query.matingId;
		this.getTableContent()

		if (this.$route.query.reminderId) {
			this.reminderId = this.$route.query.reminderId
		}

		if (this.matingId && this.reminderId) {
			const reminder = await breedingManagementService.getLitterReminderNotesById(this.matingId, this.reminderId)
			this.showAddEditReminderModal("Notif", reminder.data)
		}
	},
	methods: {
		getTableContent(page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc, fromFilter = false) {
			page = fromFilter ? 1 : this.page
			this.getLitterReminderNotes({ page, limit, sortBy, desc })
		},

		async getLitterReminderNotes(queryParams) {
			this.isAPILoading = true

			if (this.columnsFilter) {
				if (this.columnsFilter.f_notes) {
					queryParams["f_notes"] = this.columnsFilter.f_notes
				}
				if (this.columnsFilter.f_reminderType) {
					queryParams["f_reminderType"] = this.columnsFilter.f_reminderType
				}
			}

			if (this.selectedDateFilter) {
				queryParams["f_reminderDateTime"] = this.formatDateWithoutConversion(this.selectedDateFilter, "yyyy-MM-dd");
			}

			try {
				const res = await breedingManagementService.getLitterReminderNotes(this.matingId, queryParams);
				if (res.status === STATUS_CODES.SUCCESS) {
					this.tableContent = {
						tableData: res.data.data,
						paginationData: res.data.pagination,
					}

				} else {
					this.showGenericErrorToast();
				}
			} catch (err) {
				this.showGenericErrorToast();
			} finally {
				this.isAPILoading = false;
			}
		},

		setSelectedFilter(filterBy, event) {
			this.onDropdownFilter(filterBy, event);
		},

		showAddEditReminderModal(action, reminder) {
            this.$refs.modalAddEditReminderNote.show({ action, reminder, puppyList: this.puppyList, matingId: this.matingId });
        },
	},
}